import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import Login from '@/pages/Login';
import AdminDashboard from '@/pages/Admin/Dashboard';
import SuperAdminDashboard from '@/pages/SuperAdmin/SuperAdminDashboard';
import POSApp from '@/pages/POS/POSAppNew';
import POSDashboard from '@/pages/POS/POSDashboard';
import MenuManager from '@/pages/POS/MenuManager';
import AssistedOrder from '@/pages/POS/AssistedOrder';
import DeliverySettings from '@/pages/POS/DeliverySettings';
import PrintQueue from '@/pages/POS/PrintQueue';
import PaymentSettings from '@/pages/POS/PaymentSettings';
import PaymentsRefunds from '@/pages/POS/PaymentsRefunds';
import DeliveryOps from '@/pages/POS/DeliveryOps';
import CashDrawer from '@/pages/POS/CashDrawer';
import WalletLoyaltyRequests from '@/pages/POS/WalletLoyaltyRequests';
import SalesDashboard from '@/pages/POS/SalesDashboard';
import ChangePassword from '@/pages/Shared/ChangePassword';
import KitchenApp from '@/pages/Kitchen/KitchenApp';
import RiderApp from '@/pages/Rider/RiderApp';
import KioskApp from '@/pages/Kiosk/KioskApp';
import CustomerApp from '@/pages/Customer/CustomerApp';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
          <Route path="/superadmin" element={<SuperAdminDashboard />} />
          <Route path="/pos" element={<POSApp />} />
          <Route path="/pos-dashboard" element={<POSDashboard />} />
          <Route path="/pos/menu" element={<MenuManager />} />
          <Route path="/pos/assisted-order" element={<AssistedOrder />} />
          <Route path="/pos/delivery" element={<DeliverySettings />} />
          <Route path="/pos/prints" element={<PrintQueue />} />
          <Route path="/pos/payment-settings" element={<PaymentSettings />} />
          <Route path="/pos/payments" element={<PaymentsRefunds />} />
          <Route path="/pos/delivery-ops" element={<DeliveryOps />} />
          <Route path="/pos/cash" element={<CashDrawer />} />
          <Route path="/pos/wallet-loyalty" element={<WalletLoyaltyRequests />} />
          <Route path="/pos/sales-dashboard" element={<SalesDashboard />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/kitchen" element={<KitchenApp />} />
          <Route path="/rider" element={<RiderApp />} />
          <Route path="/kiosk" element={<KioskApp />} />
          {/* Customer ordering app - completely isolated */}
          <Route path="/order/*" element={<CustomerApp />} />
        </Routes>
        <Toaster position="top-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;